<div
  class="card-form-group-container"
  [formGroup]="form">
  <mat-form-field>
    <input
      matInput
      placeholder="Data di ingresso (aaaa?-mm?-gg) (PRDI)"
      formControlName="PRDI">
    <mat-error *ngIf="form?.controls?.PRDI?.hasError('iccdDate')">
      {{ 'Formato data non conforme allo standard ICCD' | translate }}
    </mat-error>
  </mat-form-field>
  <mat-form-field>
    <input
      matInput
      placeholder="Data di uscita (aaaa?-mm?-gg) (PRDU)"
      formControlName="PRDU">
      <mat-error *ngIf="form?.controls?.PRDU?.hasError('iccdDate')">
        {{ 'Formato data non conforme allo standard ICCD' | translate }}
      </mat-error>
  </mat-form-field>
</div>
